import PropTypes from 'prop-types';
import React from 'react';

import { formatCurrencyNumber } from '../../../../lib/numberFormatter';
import OfferHeader from '../OfferHeader';

import './index.scss';

const LoanOffer = ({ data, selectedOffer }) => {
  const formattedTotalAmount = formatCurrencyNumber(
    (
      Number.parseFloat(data.loan_amount) - Number.parseFloat(data.living_expense_amount || '0')
    ).toString(),
  );
  const formattedLivingExpenseAmount = formatCurrencyNumber(
    Number.parseFloat(data.living_expense_amount || '0').toString(),
  );

  return (
    <div className="loan-offer-container">
      <div className="loan-offer-container__details">
        <OfferHeader
          schoolName={data.school_short_name}
          universityName={data.university_name}
          courseName={data.course_name}
          periodStartDate={data.period_start_date}
          periodEndDate={data.period_end_date}
          seasonClassStartDate={data.season_class_start_date}
          seasonClassEndDate={data.season_class_end_date}
          tuitionFees={formattedTotalAmount}
          livingExpenses={formattedLivingExpenseAmount}
          restOfWorldCourse={data.rest_of_world_course}
          selectedOffer={selectedOffer}
        />
      </div>
    </div>
  );
};

LoanOffer.propTypes = {
  data: PropTypes.object.isRequired,
  selectedOffer: PropTypes.object,
};

export default LoanOffer;
